import '../../styles/style.scss';
import '../snippets/carousel.js';
import '../snippets/product-tile.js';
import '../vendor/proxy-link.js';
import { initInputs } from '../components/inputs.js';
import { initAccordions } from '../components/accordions.js';
import { initModals } from '../components/modals.js';
import { initMinicart } from '../components/minicart.js';
import { initVideoControls } from '../components/media.js';
import { initFirstWishlit } from '../components/wishlist';

(() => {
  initInputs();
  initAccordions();
  initModals();
  initMinicart();
  initVideoControls();
  initFirstWishlit();
})();
